.service-details-field {
  color: var(--light--text-color--1);
}

.amazon-shipping-note {
  color: var(--light--text-color--1);
}
